module.exports = "<div class=\"loader-content\">\n  <div class=\"loader\"></div>\n  <span>{{ label }}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/loader-spin/loader-spin.component.html
// module id = ./src/app/shared/components/loader-spin/loader-spin.component.html
// module chunks = main